import type { FC } from "react";

import type { SortByItemDefinition, SortByValue } from "./SortBy.types";
import { SortByItem } from "./SortByItem";

import styles from "./SortBy.module.scss";

export type SortByProps = {
  items: SortByItemDefinition[];
  value: SortByValue | undefined;
  onChange: (value: SortByValue) => void;
};

export const SortBy: FC<SortByProps> = ({ items, value, onChange }) => {
  return (
    <div className={styles.sortBy}>
      {items.map((item) => (
        <SortByItem key={item.value} {...item} checked={item.value === value} onChecked={() => onChange(item.value)} />
      ))}
    </div>
  );
};
